import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';

// HS-1635: one of the installer's installations — its tracker (`.index`) and its five stage pages
// (HS-1636–HS-1640) mount in the outlet.
export const Route = createFileRoute('/_dashboard/installer/installations/$id')({
  beforeLoad: requireRoute('/installer/installations/$id'),
  component: Outlet,
});
